import { pbNotificationsFeed } from './adapters/pb-notifications'
import type { NotificationsFeedPort } from './domain/notification'

const notificationsFeed: NotificationsFeedPort = pbNotificationsFeed

export { notificationsFeed }
